/**
 * Move an item from one index to another. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} fromIndex
 * @param {number} toIndex
 * @returns {Array}
 */
export function moveItem(items, fromIndex, toIndex) {
  if (
    fromIndex == null ||
    toIndex == null ||
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= items.length ||
    toIndex >= items.length
  ) {
    return items
  }

  const updated = [...items]
  const [moved] = updated.splice(fromIndex, 1)
  updated.splice(toIndex, 0, moved)
  return updated
}

/**
 * Move an item one position up. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} index
 * @returns {Array}
 */
export function moveUp(items, index) {
  if (index <= 0 || index >= items.length) return items

  return moveItem(items, index, index - 1)
}

/**
 * Move an item one position down. Returns the original array when unchanged.
 * @param {Array} items
 * @param {number} index
 * @returns {Array}
 */
export function moveDown(items, index) {
  if (index < 0 || index >= items.length - 1) return items

  return moveItem(items, index, index + 1)
}
